import { Outlet } from 'react-router-dom';
import { AdminNavRail } from './AdminNavRail';
import { AdminHeader } from './AdminHeader';

export default function AdminShell() {
  return (
    <div className="flex h-screen">
      <AdminNavRail />
      <div className="flex-1 overflow-auto">
        <AdminHeader />
        <main className="p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
